export enum StatusOptionsEnum {
  PRINCIPAL = 'principal',
  CANDIDATE = 'candidate',
  RESTRICTED = 'restricted',
}

export enum GenderOptionsEnum {
  MALE = 'male',
  FEMALE = 'female',
}
